module.exports = __webpack_public_path__ + "19f8c603f1272edef9293a5137af9de7.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/4_column_large_x1/public/team/Leadership_Justin_0.jpg
// module id = 363
// module chunks = 0